import axios from 'axios'
import moment from 'moment'
import Utils from '../../../utils/utils'
import CONST from '../../../utils/const'
import config from '../../../config'

export async function getHumanSensor(condition = {}) { // 取得起訖時間內，景區時間單位內的車流
  let response = {}

  let areaId = Utils.isEmptyObject(condition.areaId) ? '' : `areaId=${condition.areaId}`
  if(Utils.isEmptyObject(condition) || Utils.isEmptyObject(condition.areaId) ) {
    console.log('iisi getHumanSensor: condition error')
    return {}   
  }

  try {
    response = await axios.get(`${config.eastCoastDataApi()}HumanSensorElk/GetHumanSensor?${areaId}`)

  } catch (err) {
    console.error('iisi getHumanSensor: ', err)
    return {}
  }

  Utils.setApiResponsSuccess(response)
  return response
}